import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

const directives = [
  
]

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: directives,
  exports: directives
})
export class SharedDirectivesModule {}
